$(document).ready(function () {
  let petPhotoBase64 = null;
  let petPhotoFile = null;
  let generatedPortraitUrl = null;

  // Duo mode
  var isDuoMode = new URLSearchParams(window.location.search).get('duo') === 'true';
  let duoPetPhotos = { 1: null, 2: null }; // base64 for each pet

  const LOCALSTORAGE_KEY = 'petPosterPhoto';
  const SAVED_ARTWORKS_KEY = 'petPosterSavedArtworks';
  const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB — downscaled to 1600px before any API call
  const MAX_SAVED_ARTWORKS = 50;
  const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/heic', 'image/heif'];

  // ── Generation, per style ────────────────────────────────────────────────
  // The one event in this funnel with volume. The shop turns over roughly fifty
  // generations per order, so with orders in the low hundreds this is the only
  // place a per-style number means anything for months — a purchase count split
  // across 48 styles says nothing. Pairs with properties[__style] on the order
  // (the revenue truth, just slow) and with `style` on add_to_cart, which
  // together give generate → cart per style.
  function trackGenerate() {
    try {
      var qs = new URLSearchParams(window.location.search);
      var payload = {
        style: (qs.get('style') || '').toLowerCase() || 'none',
        style_name: qs.get('illustration_name') || '',
        material: (window.ppMaterialData && window.ppMaterialData.current) || 'paper',
        size: ($('.bp-variant-options-radio:checked').val() || ''),
        duo: isDuoMode,
      };
      if (window.posthog && window.posthog.capture) window.posthog.capture('pp_generate', payload);
      if (window.gtag) window.gtag('event', 'pp_generate', payload);
    } catch (e) {
      // Never let analytics break a generation the customer is waiting on.
    }
  }

  const $dropzone = $('#bp-pet-photo-dropzone');
  const $fileInput = $('#bp-pet-photo-input');
  const $previewImg = $('.bp-pet-photo-preview-img');
  const $removeBtn = $('.bp-pet-photo-remove-btn');
  const $generateBtn = $('#bp-ai-generate-btn');
  const $errorDisplay = $('.bp-ai-error');
  const $portraitUrlInput = $('.bp-ai-portrait-url');
  const $portraitFileInput = $('.bp-ai-portrait-file');
  const $currentIllustrationUrl = $('.bp-current-illustration-url');

  // ───────────────────────────────────────────────
  // Photo Library integration
  // ───────────────────────────────────────────────
  // Shared helper so both single-mode and duo-mode library picks can reuse the
  // "fetch image → draw to canvas → get JPEG dataUrl" flow.
  function loadPhotoUrlAsDataUrl(url, onReady, onFail) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function() {
      var c = document.createElement('canvas');
      c.width = img.width;
      c.height = img.height;
      c.getContext('2d').drawImage(img, 0, 0);
      onReady(c.toDataURL('image/jpeg', 0.92));
    };
    img.onerror = function() {
      if (url && url.indexOf('data:') === 0) { onReady(url); return; }
      if (onFail) onFail();
    };
    img.src = url;
  }

  // ───────────────────────────────────────────────
  // Remembering the pet photo between pages
  // ───────────────────────────────────────────────
  // The photo is kept in localStorage so that opening another style doesn't mean
  // uploading the pet again. But localStorage holds ~5 MB for the whole origin,
  // shared with PayPal, Klaviyo and PostHog, and we were writing the ORIGINAL
  // file as base64 — which inflates it by a third. Anything over ~3.5 MB threw
  // QuotaExceededError, and the catch only warned, so on most phones the photo
  // quietly failed to survive a move to another style. Worse, the failed write
  // left the PREVIOUS pet's photo in place to be restored instead.
  //
  // Store a downscaled copy: it only has to refill the dropzone preview. The
  // full-resolution photo stays in memory for the API call and in the photo
  // library (IndexedDB, no such limit).
  var STORED_PHOTO_MAX_PX = 1200;

  function shrinkForStorage(dataUrl, cb) {
    var img = new Image();
    img.onload = function () {
      var scale = Math.min(1, STORED_PHOTO_MAX_PX / Math.max(img.width, img.height));
      var c = document.createElement('canvas');
      c.width = Math.round(img.width * scale);
      c.height = Math.round(img.height * scale);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      try { cb(c.toDataURL('image/jpeg', 0.82)); } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = dataUrl;
  }

  function rememberPhoto(dataUrl) {
    if (!dataUrl) return;
    shrinkForStorage(dataUrl, function (small) {
      try {
        localStorage.setItem(LOCALSTORAGE_KEY, small || dataUrl);
      } catch (e) {
        // Still too big, or storage is full/blocked. Drop the key rather than
        // leaving an older pet's photo to be restored on the next page.
        try { localStorage.removeItem(LOCALSTORAGE_KEY); } catch (e2) {}
      }
    });
  }

  function checkDuoReady() {
    if (duoPetPhotos[1] && duoPetPhotos[2]) {
      $generateBtn.prop('disabled', false);
      $('.bp-duo-swap-btn').show();
    } else {
      $generateBtn.prop('disabled', true);
      $('.bp-duo-swap-btn').hide();
    }
  }

  window.ppLoadPetPhotoFromLibrary = function(url) {
    // Duo mode: route into the slot the user targeted via the per-slot ADD PHOTO
    // button. Without a target, fill the first empty slot. If BOTH slots are
    // already filled, do nothing — the photo is already saved to the library
    // (handleLibraryUpload did that). Customer can then click CHANGE on a slot
    // and pick this photo from the library.
    if (isDuoMode) {
      var petNum = window.ppDuoTarget;
      window.ppDuoTarget = null;
      if (petNum !== 1 && petNum !== 2) {
        if (!duoPetPhotos[1]) petNum = 1;
        else if (!duoPetPhotos[2]) petNum = 2;
        else return; // both slots filled — keep them, photo is in library
      }
      loadPhotoUrlAsDataUrl(url, function(dataUrl) {
        duoPetPhotos[petNum] = dataUrl;
        var $dz = $('#bp-duo-dropzone-' + petNum);
        $dz.addClass('has-photo');
        $dz.find('.bp-pet-photo-preview-img').attr('src', dataUrl);
        checkDuoReady();
        clearError();
      });
      return;
    }

    // Single-pet mode: existing behavior
    loadPhotoUrlAsDataUrl(url, function(dataUrl) {
      petPhotoBase64 = dataUrl;
      $previewImg.attr('src', dataUrl);
      $dropzone.addClass('has-photo');
      $generateBtn.prop('disabled', false);
      clearError();
      rememberPhoto(dataUrl);
    });
  };

  // Per-slot "LIBRARY" button in duo mode — sets the target and opens the library
  $(document).on('click', '.bp-duo-library-btn', function() {
    window.ppDuoTarget = parseInt($(this).attr('data-pet'), 10);
    if (window.ptpToggleLibrary) window.ptpToggleLibrary();
  });

  // ───────────────────────────────────────────────
  // Duo mode setup
  // ───────────────────────────────────────────────
  if (isDuoMode) {
    $('.bp-pet-upload-single').hide();
    $('.bp-pet-upload-duo').show();
    // Keep the bottom "📷 MY PHOTOS" button visible — even with both slots
    // filled, customers need a way to open the library and add more photos
    // (the per-slot ADD PHOTO button lives inside the placeholder which is
    // hidden once a slot is filled).

    // Handle duo file inputs
    $(document).on('change', '.bp-duo-file-input', async function() {
      var petNum = $(this).attr('data-pet');
      var file = this.files[0];
      if (!file) return;
      if (file.size > MAX_FILE_SIZE) { showError('File too large (max 50MB)'); return; }

      // Validate (HEIC may have empty file.type on iOS — check by extension too)
      var name = (file.name || '').toLowerCase();
      var type = file.type || '';
      var isHeic = name.endsWith('.heic') || name.endsWith('.heif') || type === 'image/heic' || type === 'image/heif';
      var isImage = type.startsWith('image/') || isHeic;
      if (!isImage) { showError('Please upload a JPEG, PNG, or HEIC image.'); return; }
      clearError();

      // Convert HEIC → JPEG so the browser can preview it AND Gemini can read it
      try {
        file = await convertHeicIfNeeded(file);
      } catch (err) {
        showError(err.message || 'Could not convert HEIC image.');
        return;
      }

      try {
        var dataUrl = await fileToBase64(file);
        duoPetPhotos[petNum] = dataUrl;
        var $dz = $('#bp-duo-dropzone-' + petNum);
        $dz.addClass('has-photo');
        $dz.find('.bp-pet-photo-preview-img').attr('src', dataUrl);
        checkDuoReady();
        // Auto-save to photo library so the customer can reuse this pet on
        // another duo slot or future order without re-uploading.
        if (window.ptpSaveToLibrary) {
          window.ptpSaveToLibrary(dataUrl);
        }
      } catch (err) {
        showError(err.message || 'Failed to read image.');
      }
    });

    // Handle duo drag & drop
    $(document).on('dragover', '.bp-duo-dropzone', function(e) { e.preventDefault(); $(this).addClass('dragover'); });
    $(document).on('dragleave', '.bp-duo-dropzone', function() { $(this).removeClass('dragover'); });
    $(document).on('drop', '.bp-duo-dropzone', function(e) {
      e.preventDefault(); $(this).removeClass('dragover');
      var petNum = $(this).attr('data-pet');
      var file = e.originalEvent.dataTransfer.files[0];
      if (!file) return;
      var dt = new DataTransfer(); dt.items.add(file);
      $('#bp-duo-input-' + petNum)[0].files = dt.files;
      $('#bp-duo-input-' + petNum).trigger('change');
    });

    // CHANGE button on a filled slot — open the library with that slot as the
    // target so picking a photo REPLACES the slot. If the customer wants to
    // truly empty the slot without replacing, they can use the small × button.
    $(document).on('click', '.bp-duo-remove', function() {
      var petNum = parseInt($(this).attr('data-pet'), 10);
      window.ppDuoTarget = petNum;
      if (window.ptpToggleLibrary) window.ptpToggleLibrary();
    });

    // Small × button to truly clear a slot (separate from CHANGE / replace flow)
    $(document).on('click', '.bp-duo-clear', function(e) {
      e.stopPropagation();
      var petNum = $(this).attr('data-pet');
      duoPetPhotos[petNum] = null;
      var $dz = $('#bp-duo-dropzone-' + petNum);
      $dz.removeClass('has-photo');
      $dz.find('.bp-pet-photo-preview-img').attr('src', '');
      $('#bp-duo-input-' + petNum).val('');
      checkDuoReady();
    });

    // Swap pets
    $(document).on('click', '.bp-duo-swap-btn', function() {
      var temp = duoPetPhotos[1];
      duoPetPhotos[1] = duoPetPhotos[2];
      duoPetPhotos[2] = temp;
      $('.bp-duo-preview-1').attr('src', duoPetPhotos[1] || '');
      $('.bp-duo-preview-2').attr('src', duoPetPhotos[2] || '');
      // Swap has-photo state
      var has1 = !!duoPetPhotos[1], has2 = !!duoPetPhotos[2];
      $('#bp-duo-dropzone-1').toggleClass('has-photo', has1);
      $('#bp-duo-dropzone-2').toggleClass('has-photo', has2);
    });
  }

  // ───────────────────────────────────────────────
  // Helpers
  // ───────────────────────────────────────────────

  // The four failure messages are rendered onto .bp-ai-error as data-attributes
  // by sections/petposter-product.liquid, so they arrive already translated.
  // The English text here is only a fallback for a cached page rendered before
  // those attributes existed.
  var ERROR_FALLBACK = {
    generic: 'Something went wrong while creating your portrait. Please try again.',
    busy: 'Our illustration service is very busy right now. This usually clears within a minute — please try again.',
    photo: "We couldn't create a portrait from this photo. Please try again, or upload a different one.",
    timeout: 'The request took too long. Please check your connection and try again.',
  };

  function errorText(key) {
    var attr = $errorDisplay.attr('data-error-' + key);
    return (attr && attr.trim()) || ERROR_FALLBACK[key] || ERROR_FALLBACK.generic;
  }

  function showError(message) {
    $errorDisplay.text(message).show();
  }

  function clearError() {
    $errorDisplay.text('').hide();
  }

  function setGenerateButtonLoading(loading) {
    var $overlay = $('#bp-ai-generating-overlay');
    if (loading) {
      $generateBtn
        .prop('disabled', true)
        .addClass('loading')
        .attr('data-original-text', $generateBtn.find('.bp-ai-generate-text').text());
      $generateBtn.find('.bp-ai-generate-text').hide();
      $generateBtn.find('.bp-ai-generate-loading').show();
      // Show the overlay animation
      $overlay.addClass('active');
    } else {
      $generateBtn
        .prop('disabled', false)
        .removeClass('loading success');
      $generateBtn.find('.bp-ai-generate-text').show().text($generateBtn.attr('data-original-text') || 'GENERATE PORTRAIT');
      $generateBtn.find('.bp-ai-generate-loading').hide();
      // Hide the overlay animation
      $overlay.removeClass('active');
    }
  }

  function setGenerateButtonSuccess() {
    var $overlay = $('#bp-ai-generating-overlay');
    $overlay.removeClass('active');
    $generateBtn
      .removeClass('loading')
      .addClass('success');
    $generateBtn.find('.bp-ai-generate-text').show().html('&#10003; PORTRAIT GENERATED');
    $generateBtn.find('.bp-ai-generate-loading').hide();

    setTimeout(function () {
      $generateBtn
        .removeClass('success')
        .prop('disabled', false);
      $generateBtn.find('.bp-ai-generate-text').text($generateBtn.attr('data-original-text') || 'GENERATE PORTRAIT');
    }, 3000);
  }

  function validateFile(file) {
    if (!file) return 'No file selected.';

    var type = file.type || '';
    var name = (file.name || '').toLowerCase();

    // HEIC files may not have a correct MIME type
    var isHeic = name.endsWith('.heic') || name.endsWith('.heif') || type === 'image/heic' || type === 'image/heif';
    var isImage = type.startsWith('image/') || isHeic;

    if (!isImage) return 'Please upload an image file (JPEG, PNG, or HEIC).';
    if (file.size > MAX_FILE_SIZE) return 'File is too large. Maximum size is 50MB.';

    return null;
  }

  // Downscale to 1600px longest edge as JPEG so the base64 payload stays
  // under Vercel's request body limit. Modern phones shoot 4-12MB JPEGs which
  // base64-encode to 5-16MB and trip a 413 on /api/generate-pet-portrait.
  // 1600px is plenty — Gemini and Replicate tokenize down to ~768px tiles.
  function fileToBase64(file, maxEdge, quality) {
    maxEdge = maxEdge || 1600;
    quality = quality || 0.85;
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight;
        var scale = Math.min(1, maxEdge / Math.max(w, h));
        var c = document.createElement('canvas');
        c.width = Math.round(w * scale);
        c.height = Math.round(h * scale);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        resolve(c.toDataURL('image/jpeg', quality));
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error('Failed to read file.'));
      };
      img.src = url;
    });
  }

  async function convertHeicIfNeeded(file) {
    var name = (file.name || '').toLowerCase();
    var type = file.type || '';
    var isHeic = name.endsWith('.heic') || name.endsWith('.heif') || type === 'image/heic' || type === 'image/heif';

    if (!isHeic) return file;

    if (typeof heic2any === 'undefined') {
      throw new Error('HEIC conversion is not available. Please upload a JPEG or PNG instead.');
    }

    var blob = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.85 });
    // heic2any may return an array of blobs for multi-image HEIC
    if (Array.isArray(blob)) blob = blob[0];
    return new File([blob], file.name.replace(/\.heic$/i, '.jpg').replace(/\.heif$/i, '.jpg'), {
      type: 'image/jpeg',
    });
  }

  // ───────────────────────────────────────────────
  // Photo handling
  // ───────────────────────────────────────────────

  async function handlePhotoFile(file) {
    clearError();

    var validationError = validateFile(file);
    if (validationError) {
      showError(validationError);
      return;
    }

    try {
      file = await convertHeicIfNeeded(file);
      petPhotoFile = file;

      var base64 = await fileToBase64(file);
      petPhotoBase64 = base64;

      // Show preview
      $previewImg.attr('src', base64);
      $dropzone.addClass('has-photo');

      // Enable generate button
      $generateBtn.prop('disabled', false);

      // Persist a small copy so another style page can restore it
      rememberPhoto(base64);

      // Auto-save to photo library
      if (window.ptpSaveToLibrary) {
        window.ptpSaveToLibrary(base64);
      }
    } catch (err) {
      showError(err.message || 'Failed to process the photo.');
    }
  }

  function clearPhoto() {
    petPhotoBase64 = null;
    petPhotoFile = null;
    generatedPortraitUrl = null;

    $previewImg.attr('src', '');
    $dropzone.removeClass('has-photo');
    $fileInput.val('');
    $generateBtn.prop('disabled', true);
    $portraitUrlInput.val('');
    $portraitFileInput.val('');

    clearError();

    try {
      localStorage.removeItem(LOCALSTORAGE_KEY);
    } catch (e) {
      // ignore
    }
  }

  // ───────────────────────────────────────────────
  // File input handler
  // ───────────────────────────────────────────────

  $fileInput.on('change', function () {
    var file = this.files && this.files[0];
    if (file) handlePhotoFile(file);
  });

  // ───────────────────────────────────────────────
  // Drag & drop
  // ───────────────────────────────────────────────

  // Click on dropzone opens file browser (when no photo uploaded yet)
  $dropzone.on('click', function (e) {
    if (!$(e.target).is('button, label, input') && !$dropzone.hasClass('has-photo')) {
      $fileInput.trigger('click');
    }
  });

  $dropzone.on('dragover', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).addClass('drag-over');
  });

  $dropzone.on('dragleave', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).removeClass('drag-over');
  });

  $dropzone.on('drop', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).removeClass('drag-over');

    var files = e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files;
    if (files && files.length > 0) {
      handlePhotoFile(files[0]);
    }
  });

  // ───────────────────────────────────────────────
  // Remove photo
  // ───────────────────────────────────────────────

  $removeBtn.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    // Open library instead of just clearing
    if (window.ptpToggleLibrary) {
      window.ptpToggleLibrary();
    } else {
      clearPhoto();
      restoreOriginalIllustration();
    }
  });

  // ───────────────────────────────────────────────
  // Generate portrait
  // ───────────────────────────────────────────────

  $generateBtn.on('click', async function () {
    // Duo mode validation
    if (isDuoMode) {
      if (!duoPetPhotos[1] || !duoPetPhotos[2]) {
        showError('Please upload photos of both pets.');
        return;
      }
    } else if (!petPhotoBase64) {
      showError('Please upload a photo of your pet first.');
      return;
    }

    var illustrationUrl = $currentIllustrationUrl.val();
    if (!illustrationUrl) {
      // Fallback: grab from the current illustration image
      illustrationUrl = $('.bp-illustration-img').attr('src');
    }

    // Fix protocol-relative URLs (//domain.com/...) to absolute
    if (illustrationUrl && illustrationUrl.startsWith('//')) {
      illustrationUrl = 'https:' + illustrationUrl;
    }

    if (!illustrationUrl) {
      showError('No illustration selected. Please choose an illustration first.');
      return;
    }

    var illustrationName = '';
    try {
      illustrationName = document.title || $('h1').first().text() || '';
    } catch (e) {
      // not critical
    }

    clearError();
    setGenerateButtonLoading(true);

    var apiUrl = (typeof AI_API_URL !== 'undefined' ? AI_API_URL : '') + '/api/generate-pet-portrait';

    try {
      var requestData = {
        petPhoto: isDuoMode ? duoPetPhotos[1] : petPhotoBase64,
        illustrationUrl: illustrationUrl,
        illustrationName: illustrationName,
      };
      if (isDuoMode) {
        requestData.petPhoto2 = duoPetPhotos[2];
        requestData.isDuo = true;
      }
      // Style-transfer experimental flag: ?useRef=1 in the URL enables passing
      // the sample illustration as a style reference (2-image input). Off by
      // default — see reference_aquarelle_generation_pipeline.md for the
      // identity-bleed trade-off.
      try {
        var qs = new URLSearchParams(window.location.search);
        if (qs.get('useRef') === '1') requestData.useReference = true;
        // Style product handle — lets the generator use the prompt staff set on that product.
        if (qs.get('style')) requestData.styleHandle = qs.get('style');
      } catch (e) {}

      var response = await $.ajax({
        url: apiUrl,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(requestData),
        timeout: 180000, // 3 minutes for duo (more complex generation)
      });

      if (response.imageUrl) {
        // imageUrl = watermarked preview (shown to user, screenshot-resistant).
        // imageUrlClean = clean original sent to Gelato via the cart property.
        var displayUrl = response.imageUrl;
        var cleanUrl = response.imageUrlClean || response.imageUrl;
        generatedPortraitUrl = displayUrl;
        // Cart property uses the CLEAN url so the printed poster has no watermark.
        $portraitUrlInput.val(cleanUrl);

        // Update the poster preview — use base64 for hidden-preview (CORS-safe for screenshot)
        // and URL for visible preview
        updatePosterWithAiPortrait(displayUrl);
        if (response.imageBase64) {
          $('.hidden-preview .bp-illustration-img').attr('src', response.imageBase64);
        }

        // Save to artworks gallery — store both URLs so re-selecting an old creation
        // still resolves the clean version for the cart.
        addSavedArtwork(displayUrl, cleanUrl);

        // Convert to file for form submission if base64 is available
        if (response.imageBase64) {
          try {
            var fileFromUrl = dataURLtoFile(response.imageBase64, 'ai-portrait.png');
            var dataTransfer = new DataTransfer();
            dataTransfer.items.add(fileFromUrl);
            $portraitFileInput[0].files = dataTransfer.files;
          } catch (e) {
            console.warn('Could not set portrait file input:', e.message);
          }
        }

        trackGenerate();

        setGenerateButtonSuccess();
      } else {
        var noImage = new Error('no image in response');
        noImage.ppStatus = 422;
        throw noImage;
      }
    } catch (err) {
      // The customer sees OUR copy, chosen from the status code — never the
      // server's error text. That text is written for the logs (it names the
      // model and the provider), and a raw `details` field carries a stack
      // trace. Neither belongs in front of a customer.
      var status = err.ppStatus || err.status;
      var key = 'generic';
      var isRetryable = false;
      if (status === 0 || err.statusText === 'timeout') {
        key = 'timeout';
        isRetryable = true;
      } else if (status === 422) {
        // The model answered without an image — usually the photo itself.
        key = 'photo';
      } else if (status === 503 || (status >= 500 && status < 600)) {
        key = 'busy';
        isRetryable = true;
      }
      if (err.responseJSON && typeof err.responseJSON.retryable === 'boolean') {
        isRetryable = err.responseJSON.retryable;
      }
      console.warn('[pp-ai] generation failed (' + status + '):',
        (err.responseJSON && err.responseJSON.error) || err.message);
      showError(errorText(key));
      setGenerateButtonLoading(false);
      // Re-enable the button regardless — the user should be able to retry.
      $generateBtn.prop('disabled', false);
    }
  });

  // ───────────────────────────────────────────────
  // Update poster preview with AI portrait
  // ───────────────────────────────────────────────

  function updatePosterWithAiPortrait(imageUrl) {
    ['.petposter-template', '.hidden-preview'].forEach(function(container) {
      var $img = $(container + ' .bp-illustration-img');
      var $illustrationDiv = $(container + ' .bp-preview-illustration');

      // Store originals for restore
      if (!$img.attr('data-original-src')) {
        $img.attr('data-original-src', $img.attr('src'));
      }

      // Swap the image and make it fill the illustration area edge-to-edge.
      // Also clear display:none — Liquid renders that on variants with no
      // illustration_variants metafield (e.g. "Hi-Res Digital Printing File"),
      // so on reload-with-AI-portrait the image src is set correctly but
      // stays invisible until we explicitly un-hide it.
      $img.attr('src', imageUrl);
      $img.css({
        'mix-blend-mode': 'normal',
        'width': '100%',
        'height': '100%',
        'object-fit': 'cover',
        'position': 'absolute',
        'top': '0',
        'left': '0',
        'display': ''
      });
      $img.removeAttr('height');
      $img.removeClass('auto-contrast');
      // Hide the "🐾 Upload your photo" placeholder when an AI portrait shows
      var $placeholder = $img.siblings('.bp-illustration-placeholder');
      if ($placeholder.length) $placeholder.hide();

      // Make container fill and clip
      $illustrationDiv.css({
        'overflow': 'hidden',
        'position': 'relative'
      });

      // Hide signature
      $(container + ' .bp-signature').hide();
    });
  }

  function restoreOriginalIllustration() {
    ['.petposter-template', '.hidden-preview'].forEach(function(container) {
      var $img = $(container + ' .bp-illustration-img');
      var $illustrationDiv = $(container + ' .bp-preview-illustration');
      var originalSrc = $img.attr('data-original-src');

      if (originalSrc) {
        $img.attr('src', originalSrc);
        $img.css({ 'mix-blend-mode': '', 'width': '', 'height': '', 'object-fit': '', 'position': '', 'top': '', 'left': '' });
        $img.attr('height', '87.25%');
        $img.removeAttr('data-original-src');
      }

      $illustrationDiv.css('overflow', '');
      $(container + ' .bp-signature').show();
    });

    generatedPortraitUrl = null;
    $portraitUrlInput.val('');
    $portraitFileInput.val('');
  }

  // ───────────────────────────────────────────────
  // Illustration change handler
  // ───────────────────────────────────────────────

  $(document).on('change', '.bp-illustration-radio', function () {
    var newImageUrl = $(this).attr('data-image');

    // Clear any generated portrait
    generatedPortraitUrl = null;
    $portraitUrlInput.val('');
    $portraitFileInput.val('');

    // Remove the data-original-src so the new illustration becomes the base
    $('.bp-illustration-img').removeAttr('data-original-src');
    $('.hidden-preview .bp-illustration-img').removeAttr('data-original-src');

    // Update the current illustration URL hidden input
    if (newImageUrl) {
      $currentIllustrationUrl.val(newImageUrl);
    }

    // Re-enable generate button if a photo is uploaded
    if (petPhotoBase64) {
      $generateBtn.prop('disabled', false);
      $generateBtn.removeClass('success').text($generateBtn.attr('data-original-text') || 'Generate');
    }

    clearError();
  });

  // ───────────────────────────────────────────────
  // Utility: data URL to File
  // ───────────────────────────────────────────────

  function dataURLtoFile(dataUrl, filename) {
    var arr = dataUrl.split(',');
    var mimeMatch = arr[0].match(/:(.*?);/);
    var mime = mimeMatch ? mimeMatch[1] : 'image/png';
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  // ───────────────────────────────────────────────
  // LocalStorage restore on page load
  // ───────────────────────────────────────────────

  (function restoreFromLocalStorage() {
    try {
      var stored = localStorage.getItem(LOCALSTORAGE_KEY);
      if (stored && stored.startsWith('data:image')) {
        petPhotoBase64 = stored;
        $previewImg.attr('src', stored);
        $dropzone.addClass('has-photo');
        $generateBtn.prop('disabled', false);
      }
    } catch (e) {}
  })();

  // ───────────────────────────────────────────────
  // Saved artworks gallery
  // ───────────────────────────────────────────────

  function getSavedArtworks() {
    try {
      var data = localStorage.getItem(SAVED_ARTWORKS_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  function saveSavedArtworks(artworks) {
    try {
      localStorage.setItem(SAVED_ARTWORKS_KEY, JSON.stringify(artworks));
    } catch (e) {}
  }

  function addSavedArtwork(imageUrl, cleanUrl) {
    var artworks = getSavedArtworks();
    // Don't add duplicates
    if (artworks.some(function(a) { return a.url === imageUrl; })) return;
    artworks.unshift({
      url: imageUrl,
      cleanUrl: cleanUrl || imageUrl,
      date: new Date().toISOString(),
      product: document.title || ''
    });
    // Keep max
    if (artworks.length > MAX_SAVED_ARTWORKS) artworks = artworks.slice(0, MAX_SAVED_ARTWORKS);
    saveSavedArtworks(artworks);
    renderSavedArtworks();
  }

  function removeSavedArtwork(index) {
    var artworks = getSavedArtworks();
    artworks.splice(index, 1);
    saveSavedArtworks(artworks);
    renderSavedArtworks();
  }

  function renderSavedArtworks() {
    var artworks = getSavedArtworks();
    var $grid = $('.bp-saved-artworks-grid');
    var $clearBtn = $('.bp-saved-artworks-clear');
    var $empty = $('.bp-saved-artworks-empty');

    $grid.empty();

    if (artworks.length === 0) {
      $clearBtn.hide();
      $empty.show();
      return;
    }

    $clearBtn.show();
    $empty.hide();

    artworks.forEach(function(artwork, index) {
      var $item = $('<div>').addClass('bp-saved-artwork-item')
        .attr('data-index', index)
        .attr('data-url', artwork.url)
        // Store clean (un-watermarked) URL for the cart property
        .attr('data-clean-url', artwork.cleanUrl || artwork.url);

      var $img = $('<img>').attr('src', artwork.url).attr('alt', 'Saved portrait');

      var $delete = $('<button>').addClass('bp-saved-artwork-delete')
        .attr('type', 'button')
        .html('&times;')
        .attr('data-index', index);

      $item.append($img).append($delete);
      $grid.append($item);

      // Mark as active if this is the currently displayed portrait
      if (generatedPortraitUrl === artwork.url) {
        $item.addClass('active');
      }
    });
  }

  // Click saved artwork to load it
  $(document).on('click', '.bp-saved-artwork-item', function(e) {
    if ($(e.target).hasClass('bp-saved-artwork-delete')) return;
    var url = $(this).attr('data-url');
    var cleanUrl = $(this).attr('data-clean-url') || url;
    if (url) {
      generatedPortraitUrl = url;
      // Cart property = clean (printed by Gelato without watermark)
      $portraitUrlInput.val(cleanUrl);
      updatePosterWithAiPortrait(url);
      $('.bp-saved-artwork-item').removeClass('active');
      $(this).addClass('active');
    }
  });

  // Is the poster currently showing this artwork?
  function isShowingArtwork(a) {
    if (!a) return false;
    var shown = $('.petposter-template .bp-illustration-img').attr('src') || '';
    return shown === a.url || shown === a.cleanUrl ||
           generatedPortraitUrl === a.url || generatedPortraitUrl === a.cleanUrl;
  }

  // Delete saved artwork.
  //
  // Deleting the artwork that is on the poster used to leave it there, pointing
  // at a file that is no longer offered — the customer saw the portrait they
  // had just deleted, and a blank white poster once the image stopped
  // resolving. Fall back to the style's own sketch, which is what the page
  // showed before anything was generated.
  $(document).on('click', '.bp-saved-artwork-delete', function(e) {
    e.stopPropagation();
    var index = parseInt($(this).attr('data-index'));
    var removed = getSavedArtworks()[index];
    removeSavedArtwork(index);
    if (isShowingArtwork(removed)) restoreOriginalIllustration();
  });

  // Clear all saved artworks — nothing is left to show, so always go back to
  // the sketch.
  $('.bp-saved-artworks-clear').on('click', function() {
    saveSavedArtworks([]);
    renderSavedArtworks();
    restoreOriginalIllustration();
  });

  // Save artwork when generated (hook into the success callback)
  var originalSetSuccess = setGenerateButtonSuccess;
  // We need to save after generation - modify the generate handler
  // The save happens in the generate click handler where we set generatedPortraitUrl

  // Render saved artworks and restore last used one on page load
  renderSavedArtworks();

  // Applies a restored AI portrait URL to the poster preview + "Your Creations".
  function applyRestoredAiPortrait(restoredUrl) {
    restoredUrl = (restoredUrl || '').trim();
    if (!restoredUrl || !/^https?:\/\//i.test(restoredUrl)) return false;
    var testImg = new Image();
    testImg.onload = function() {
      generatedPortraitUrl = restoredUrl;
      updatePosterWithAiPortrait(restoredUrl);
      addSavedArtwork(restoredUrl);
      $('.bp-saved-artwork-item[data-url="' + restoredUrl + '"]').addClass('active');
    };
    testImg.onerror = function() {
      console.warn('Restored AI portrait URL not accessible:', restoredUrl);
    };
    testImg.src = restoredUrl;
    return true;
  }

  // When the `?d=<token>` server-side restore completes (async), re-check the
  // hidden input — pp-local-storage-handler fires this after filling the form.
  // The local-storage handler may have just merged a server-side artworks array
  // into localStorage; re-render the gallery so the customer sees every
  // generation, not just the active one.
  $(document).on('pp:design-restored', function() {
    renderSavedArtworks();
    applyRestoredAiPortrait($portraitUrlInput.val());
  });

  // Auto-load the most recent saved artwork into the poster preview
  // Skip if a new illustration is being loaded via URL params (from collection product click)
  (function restoreSavedArtwork() {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('illustration')) return; // New illustration loading — don't restore old artwork

    // Priority 1: sync restore from the legacy `?values=` blob (still supported).
    // The async `?d=<token>` path is handled by the pp:design-restored event above.
    if (applyRestoredAiPortrait($portraitUrlInput.val())) return;

    // Priority 2: most recent localStorage artwork (same device, returning user)
    var artworks = getSavedArtworks();
    if (artworks.length > 0) {
      var latest = artworks[0];
      // Verify the image URL is still accessible before applying
      var testImg = new Image();
      testImg.onload = function() {
        generatedPortraitUrl = latest.url;
        // CRITICAL: cart property MUST be the CLEAN url (no watermark) — Gelato
        // prints from this. latest.url is the watermarked DISPLAY version; the
        // un-watermarked file is at latest.cleanUrl. Order #1026 shipped with
        // the watermark visible on the print because this line read latest.url.
        $portraitUrlInput.val(latest.cleanUrl || latest.url);
        updatePosterWithAiPortrait(latest.url);
        $('.bp-saved-artwork-item').first().addClass('active');
      };
      testImg.onerror = function() {
        // URL expired or broken — remove it and keep original illustration
        console.warn('Saved artwork URL no longer accessible, removing.');
        removeSavedArtwork(0);
      };
      testImg.src = latest.url;
    }
  })();
});
